import React from "react";
import "./Graphic.css";
function Graphicwork(){

    return(
        <div className="contents">
  <div className="container">
  {/* <!-- Row 1: Three Cards --> */}
  <div className="row justify-content-center g-4">
    <div className="col-md-4">
      <div className="cardid card border border-dark">

                      <div className="corner-circle bg-primary"></div>

        <div className="card-body">
          <h5 className="card-title">
              <img src="poster1.png" alt="Logo"/>
            Poster Design</h5>
          <p className="card-text">We design posters that are visually striking, professionally crafted, and tailored to grab attention. Our creative designs are print-ready, mobile-optimized, and perfect for promotions, events, and branding. Based in Coimbatore, we offer affordable custom poster design services using the latest tools and techniques. Need eye-catching visuals? Hire us to bring your message to life and make a lasting impression</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className=" cardid card  border border-dark">

                      <div className="corner-circle bg-primary"></div>

        <div className="card-body">
         <h5 className="card-title">
        <img src="logodesign.png" alt="Logo"/>
            Logo Design</h5>
          <p className="card-text">We create logos that are unique, memorable, and aligned with your brand identity. Our designs are clean, scalable, and made to stand out—whether on a business card or billboard. Offering affordable custom logo design services in Coimbatore, we focus on creativity and clarity to ensure your brand leaves a lasting mark. Need a logo that speaks for your business? Let us design it with purpose and professionalism.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle bg-primary"></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="image.png" alt="Logo"/>
            Image Edit</h5>
          <p className="card-text">We provide professional image editing services that enhance, retouch, and transform your visuals with precision. From background removal and color correction to creative photo manipulation—we make your images stand out. Based in Coimbatore, we offer affordable, high-quality edits tailored to your needs. Need polished, eye-catching photos?<br/>
           Let us bring your images to life with style and accuracy.</p>
        </div>
      </div>
    </div>
  </div>

  <div className="row justify-content-center g-4 mt-3">
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle bg-primary"></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="videoedi.png" alt="Logo"/>
            Video Editing</h5>
          <p className="card-text">We offer professional video editing services that turn raw footage into compelling visual stories. From cuts and transitions to sound design and effects—we craft videos that capture attention and deliver impact. Whether it’s for social media, business, or personal projects, our affordable video editing services in Coimbatore ensure high-quality, engaging results. Need your videos to stand out? Let us edit them with creativity and precision.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle bg-primary"></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="voiceover.png" alt="Logo"/>
            Voice Over</h5>
          <p className="card-text">We deliver professional voice-over services that bring your scripts to life with clarity, emotion, and impact. From commercials and explainer videos to audiobooks and YouTube content—we provide high-quality recordings tailored to your brand’s tone. Based in Coimbatore, we offer affordable voice-over solutions in multiple languages. Need a voice that connects with your audience? Let us be the voice behind your message.</p>
        </div>
      </div>
    </div>
  </div>
</div>


<button type="button" className="exitbutton btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Move to Previous
</button>


<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Exit page</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      Are You Really want to Exit this page..
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
        <button type="button" class="btn btn-primary">Yes</button>
      </div>
    </div>
  </div>
</div>


        </div>
    )

}
export default Graphicwork;